import { Suspense, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import {
  Button,
  Card,
  // Drawer,
  message,
  Result,
  Space,
} from 'antd';
import {
  //  CloseOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
// import Empty from 'components/Empty';
import useModal from 'hooks/useModal';
import useEnterprise from './hooks/useEnterprise';
import EnterpriseForm from './components/EnterpriseForm';
import CompanyForm from './components/CompanyForm';
// import emptyImage from './assets/enterpriseEmpty.png';

// const Content = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   > dl {
//     flex: 0 0 33.3333%;
//     margin-bottom: 30px;
//     padding-right: 30px;
//     overflow: hidden;
//     > * {
//       font-size: 14px;
//       font-weight: normal;
//       color: #515359;
//       word-wrap: break-word;
//     }
//     img {
//       width: auto;
//       height: 120px;
//     }
//   }
// `;

// const Footer = styled.div`
//   button {
//     margin-right: 16px;
//   }
// `;

const TextButton = styled(Button)`
  padding: 0 0;
`;

function Enterprise() {
  const { t } = useTranslate();

  const { item: enterprise, loading, error, fetch, update } = useEnterprise();

  const { visible, show, hide } = useModal();

  const refsCurrent = {
    fetch,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;
  useEffect(() => {
    const {
      current: { fetch },
    } = refs;

    fetch().catch(() => {});
  }, []);

  if (loading && !enterprise) {
    return (
      <Card title={t('enterprise.开票信息')}>
        <LoadingOutlined />
      </Card>
    );
  }

  if (error) {
    return (
      <Card title={t('enterprise.开票信息')}>
        <Result
          status="500"
          title={t('app_error_title')}
          subTitle={t('app_error_subTitle')}
          extra={
            <Button
              type="primary"
              onClick={() => {
                fetch().catch(() => {});
              }}
            >
              {t('app_reload_now')}
            </Button>
          }
        />
      </Card>
    );
  }

  const initialValues = enterprise
    ? {
        ...enterprise,
        image: enterprise.image
          ? [
              {
                uid: '1',
                name: '1',
                url: enterprise.image,
              },
            ]
          : [],
      }
    : undefined;
  const enterpriseForm = (
    <EnterpriseForm
      mode={visible ? 'modify' : 'read'}
      initialValues={initialValues}
      onSubmit={(values, helpers) => {
        const { image: fileList = [], ...others } = values;

        const [
          { url: image } = {
            url: undefined,
          },
        ] = fileList;

        const submitValues = {
          ...others,
          image,
        };

        return update(submitValues, true)
          .then(() => {
            message.success(t('operation.saveSucceed'));

            helpers.resetForm();

            hide();
          })
          .catch(() => {
            message.error(t('operation.saveFailed'));
          });
      }}
    >
      {(form, formProps) => {
        const { isSubmitting, resetForm, submitForm } = formProps;
        return (
          <Card
            loading={isSubmitting}
            title={t('enterprise.开票信息')}
            extra={
              visible ? (
                <Space size={24}>
                  <TextButton
                    onClick={() => {
                      hide();
                      resetForm();
                    }}
                    type="link"
                  >
                    {t('enterprise.取消')}
                  </TextButton>
                  <TextButton htmlType="submit" type="link" onClick={() => submitForm()}>
                    {t('enterprise.保存')}
                  </TextButton>
                </Space>
              ) : (
                <Button onClick={show}>{t('enterprise.编辑信息')}</Button>
              )
            }
          >
            {form}
          </Card>
        );
      }}
    </EnterpriseForm>
  );

  return (
    <>
      <Suspense fallback={<Card loading={loading} title="公司信息" />}>
        <CompanyForm />
      </Suspense>
      {enterpriseForm}
    </>
  );
}

export default Enterprise;
